import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { resourcesConfigurationRoute,activeConfiguration,activeLockConfiguration } from '../../helpers/backend_helper';
import {DestroyAlertHelper,Alert} from '../../helpers/alerts/alertHelper';
import { getPolicyUser,getStorageUser } from '../../helpers/api_helper';
import {Container} from "reactstrap";
import { useParams } from 'react-router-dom';
import ButtonHelper from '../../helpers/ButtonHelper';

const RouteConfigurations = () => {
    const {id} = useParams();
    const policy = getPolicyUser();
    const authUser = getStorageUser();
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false,update:false});
    const [dataPag, setDataPag] = useState({total:0});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc',companySession:authUser.company_id});
    const [items, setItems] = useState([]);
    const [itemBase, setItemBase] = useState({
        id: 0,
        departure:0,
        platform_price:0,
        pasage_price:0,
        max_speed:0,
        lock:false,
        active:false,
        geofence:null,
        geofence_id:null,
        route_id:id
    });
    const [item, setItem] = useState(itemBase);
    const getResource = (row) => {
        let params={params:filters}
        setPending(true)
        resourcesConfigurationRoute('show',params,id).then(response => {
            setItems(response.data)
            let meta={
                current_page:response.data.current_page,
                from:response.data.from,
                last_page:response.data.last_page,
                links:response.data.links,
                path: response.data.path,
                per_page: response.data.per_page,
                to: response.data.to,
                total: response.data.total,
            }
            setDataPag(meta)
            
            setPending(false)
        })
    }
    useEffect(() => {
        getResource()
    }, [filters])

    const handlerOnChange = (id,e=false) =>{
        const newItem = items.filter(c => {
            if(c.id==id){
                if(e){
                    c.value = e.target.value;
                    c.is_modified = true
                }else{
                    c.is_modified = false    
                }
                return c
            }
        })[0]
        let array = [];
        array = items.map(item => item.id !== newItem.id ? item : newItem);
        setItems(array);
    }

    const columns = Columns(id,handlerOnChange);
	document.title = "Configuración | Sistema de logística";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper filterInp={false} tittle="Configuración de Rutas" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal 
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        item={item}
                        setItem={setItem}
                        authUser={authUser}
                        id={id}
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default RouteConfigurations;